import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Heading,
  Text,
  Stack,
  StackDivider,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { IoAnalyticsSharp, IoLogoBitcoin, IoSearchSharp } from "react-icons/io5";
import Lottie from "lottie-react";
import animationData1 from "assets/animations/esign.json";
import animationData2 from "assets/animations/insights.json";
import animationData3 from "assets/animations/doc.json";

const Feature = ({ text, icon, iconBg }) => {
  return (
    <Stack direction={"row"} align={"center"} spacing={{ base: 2, md: 3, lg: 4 }}>
      <Flex w={8} h={8} align={"center"} justify={"center"} rounded={"full"} bg={iconBg}>
        {icon}
      </Flex>
      <Text fontWeight={600}>{text}</Text>
    </Stack>
  );
};

function SplitWithImage({ title, subTitle, heading, image, position, animationData }) {
  const isEven = position % 2 === 0;

  return (
    <Container maxW={"full"} pb={{ base: 8, md: 12, lg: 16 }}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <Flex order={{ base: 0, md: isEven ? 0 : 1 }} align="center" justify="center" height="100%">
          <Lottie animationData={animationData} style={{ width: 300, height: 300 }} />
        </Flex>
        <Stack order={{ base: 1, md: isEven ? 1 : 0 }} spacing={4}>
          <Text
            textTransform={"uppercase"}
            color={"blue.400"}
            fontWeight={600}
            fontSize={{ base: "xs", md: "sm" }}
            bg={useColorModeValue("blue.50", "blue.900")}
            p={2}
            alignSelf={"flex-start"}
            rounded={"md"}
          >
            {heading}
          </Text>
          <Heading fontSize={{ base: "lg", md: "xl", lg: "2xl" }}>{title}</Heading>
          <Text color={"gray.500"} fontSize={{ base: "sm", md: "md", lg: "lg" }}>
            {subTitle}
          </Text>
          <Stack
            spacing={{ base: 2, md: 3, lg: 4 }}
            divider={<StackDivider borderColor={useColorModeValue("gray.100", "gray.700")} />}
          >
            <Feature
              icon={<Icon as={IoAnalyticsSharp} color={"yellow.500"} w={5} h={5} />}
              iconBg={useColorModeValue("yellow.100", "yellow.900")}
              text={"Business Planning"}
            />
            <Feature
              icon={<Icon as={IoLogoBitcoin} color={"green.500"} w={5} h={5} />}
              iconBg={useColorModeValue("green.100", "green.900")}
              text={"Financial Planning"}
            />
            <Feature
              icon={<Icon as={IoSearchSharp} color={"purple.500"} w={5} h={5} />}
              iconBg={useColorModeValue("purple.100", "purple.900")}
              text={"Market Analysis"}
            />
          </Stack>
        </Stack>
      </SimpleGrid>
    </Container>
  );
}

export default function Features() {
  return (
    <>
      <SplitWithImage
        position={1}
        heading="Key Features"
        title="Document Insights"
        subTitle="Get valuable summaries and highlights from your documents, agreements, and contracts"
        animationData={animationData1}
      />
      <SplitWithImage
        position={2}
        heading="Key Features"
        title="E-Signature Compatibility"
        subTitle="Easily sign documents with legally binding e-signatures that meet industry standards."
        animationData={animationData2}
      />
      <SplitWithImage
        position={3}
        heading="Key Features"
        title="Document Management"
        subTitle="Organize and track all your signed documents in one secure location."
        animationData={animationData3}
      />
    </>
  );
}
